export const constants = {
  PASSWORD_LENGTH: 6
};
